import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import cx from 'classnames';
import { card } from '../Forum.module.scss';
import styles from './ForumActivities.module.scss';
import Postcard from '../Postcard/Postcard';
import { Link } from 'react-router-dom';
import { getActivities } from 'redux/modules/forum';
import { isEmpty } from 'lodash';

const Answer = ({ question, answer, _id }) => {
  return (
    <div className={cx(card, styles.answer)}>
      <div className={styles.title}>Answered on &ldquo;{question}&rdquo;</div>
      <div className={styles.answerText}>{answer}</div>
      <Link to={`/forum/questions/${_id}/${question}`}>View Full Answer</Link>
    </div>
  );
};

Answer.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  _id: PropTypes.string.isRequired,
};

const ForumActivities = ({ activities, getActivities, auth, user }) => {
  useEffect(() => {
    getActivities({ _id: user._id });
  }, [getActivities, user._id]);
  const isOwnProfile = useMemo(() => user._id === auth, [auth, user]);
  const title = useMemo(
    () => `${isOwnProfile ? 'My' : `${user.name}'s`} Forum Activities`,
    [user, isOwnProfile]
  );
  const list =
    useMemo(() => !isEmpty(activities) && activities[user._id], [
      activities,
      user._id,
    ]) || [];
  return (
    <div
      className={
        isOwnProfile
          ? 'page-content col-lg-8 col-md-8 col-sm-12 col-xs-12'
          : 'section-content col-lg-9 col-md-9 col-sm-12 col-xs-12'
      }
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className="cs-user-content cs-instructor">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="cs-section-title">
              {isOwnProfile ? <h2>{title}</h2> : <h3>{title}</h3>}
            </div>
          </div>
        </div>
        <div className={styles.cardList}>
          {list.length > 0 ? (
            list.map((data, i) =>
              data.author ? (
                <Postcard {...data} key={i} topic="activities" />
              ) : (
                <Answer {...data} key={i} />
              )
            )
          ) : (
            <div>No activities found.</div>
          )}
        </div>
      </div>
    </div>
  );
};

ForumActivities.propTypes = {
  activities: PropTypes.object.isRequired,
  getActivities: PropTypes.func.isRequired,
  auth: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

ForumActivities.defaultProps = {
  activities: {},
};

export default connect(
  ({ auth: { user }, forum: { activities } }) => ({ auth: user, activities }),
  { getActivities }
)(ForumActivities);
